import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { WORKSPACE_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateWorkspace(
    $id: ID!
    $name: String!
    $memberEmails: [String!]
    $allowAll: Boolean
    $promptIds: [ID!]
    $templateIds: [ID!]
    $integrations: [WorkspaceIntegrationInput!]
    $resourceIds: [ID!]
    $projectIds: [ID!]
    $brandVoiceIds: [ID!]
    $defaultBrandVoiceId: ID
    $visualLanguageIds: [ID!]
    $defaultVisualLanguageId: ID
  ) {
    updateWorkspace(
      id: $id
      name: $name
      memberEmails: $memberEmails
      allowAll: $allowAll
      promptIds: $promptIds
      templateIds: $templateIds
      integrations: $integrations
      resourceIds: $resourceIds
      projectIds: $projectIds
      brandVoiceIds: $brandVoiceIds
      defaultBrandVoiceId: $defaultBrandVoiceId
      visualLanguageIds: $visualLanguageIds
      defaultVisualLanguageId: $defaultVisualLanguageId
    ) {
      ...Workspace
    }
  }
  ${WORKSPACE_FRAGMENT}
`;

export const updateWorkspace = async ({
  id,
  name,
  memberEmails,
  allowAll,
  integrations,
  promptIds,
  templateIds,
  resourceIds,
  projectIds,
  brandVoiceIds,
  defaultBrandVoiceId,
  visualLanguageIds,
  defaultVisualLanguageId,
}) => {
  const variables = {
    id,
    name,
    memberEmails,
    allowAll,
    integrations,
    promptIds,
    templateIds,
    resourceIds,
    projectIds,
    brandVoiceIds,
    defaultBrandVoiceId,
    visualLanguageIds,
    defaultVisualLanguageId,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
